import { render, staticRenderFns } from "./sidePanel.vue?vue&type=template&id=40fa4aa4&scoped=true&"
import script from "./sidePanel.vue?vue&type=script&lang=js&"
export * from "./sidePanel.vue?vue&type=script&lang=js&"
import style0 from "./sidePanel.vue?vue&type=style&index=0&id=40fa4aa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa4aa4",
  null
  
)

export default component.exports